import { render, staticRenderFns } from "./frontHeaderFicha.vue?vue&type=template&id=00ac9dd8&scoped=true&"
import script from "./frontHeaderFicha.vue?vue&type=script&lang=js&"
export * from "./frontHeaderFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ac9dd8",
  null
  
)

export default component.exports